import React, { useState } from "react";
import { useTheme } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import ViewSelector from "./ViewSelector";
import SwipeableViews from "react-swipeable-views";
import PropTypes from "prop-types";


const TabView = ({ children, viewNames }) => {
  const theme = useTheme();
  const [activeView, setActiveView] = useState(0);

  return (
    <div >
      <ViewSelector
        activeView={activeView}
        setActiveView={setActiveView}
      >
        {viewNames.map((option, index) => {
          return (
            <Tab
              key={index}
              className={activeView === index ? `view activeView` : `view`}
              label={option}
            ></Tab>
          );
        })}
      </ViewSelector>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={activeView}
      >
        {children}
      </SwipeableViews>
    </div>
  );
};

TabView.propTypes = {
  children: PropTypes.node.isRequired,
  viewNames: PropTypes.array.isRequired,
};

export default TabView;
